import React from 'react';
import { LessonType } from '../../../redux/types/live.type';

export function Tab(props: any) {
  const { lessonType, tabValue, onTabChanged } = props;

  return (
    <div className="tabbar">
      {String(lessonType) === String(LessonType.Vod) && (
        <span
          className={`markup-item tab-item  ${tabValue === 0 ? 'active' : ''} `}
          onClick={() => onTabChanged(0)}
        >
          <span />
          实录标记
        </span>
      )}
      <span
        className={`tab-item  ${tabValue === 1 ? 'active' : ''} `}
        onClick={() => onTabChanged(1)}
      >
        相关资料
      </span>
    </div>
  );
}
